import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState, useContext } from 'react'
import TransactionItems from '../TransactionItem/TransactionItems'
import { createRecurrences } from '../../utilities/general-utils'
import { InputVarsContext } from '../../contexts/input-vars-context'
import { svc_getExceptionsByTransactionId } from "../../services/transaction.service"
import { TransactionDisplayContext } from "../../contexts/transaction-display-context";

const UpcomingTransactions = ({ transaction, setHasExceptions, userId }) => {
    const { getAccessTokenSilently } = useAuth0();
    const { vars } = useContext(InputVarsContext)
    const [transactionsList, setTransactionsList] = useState(null)
    const { transactionDisplaySettings, setTransactionDisplaySettings } = useContext(TransactionDisplayContext)

    const getTransactions = async () => {
        const accessToken = await getAccessTokenSilently();
        let exceptions = [];

        const {data, error} = await svc_getExceptionsByTransactionId(
            accessToken,
            userId,
            transaction.id
        );

        if (data && data.length > 0) {
            setHasExceptions(true)
            exceptions = await data
        }

        let recurrences = []

        if (transaction) {
            recurrences = createRecurrences(
                [transaction],
                exceptions,
                vars.dateRange.startDate,
                vars.dateRange.endDate,
                null
            )
        }

        return recurrences
    }

    const getUpcomingTransactions = async () => {
        const transactions = await getTransactions();
        setTransactionsList(transactions)
    }

    useEffect(() => {
        if (vars.dateRange.startDate && vars.dateRange.endDate && transaction) {
            getUpcomingTransactions()
        }
    }, [vars.dateRange.startDate, vars.dateRange.endDate, transaction])

    useEffect(() => {
        if (!transactionDisplaySettings.hideExceptionLinkToTransactions) {
            setTransactionDisplaySettings({
                ...transactionDisplaySettings,
                hideExceptionLinkToTransactions: true
            })
        }
    }, [transactionDisplaySettings.hideExceptionLinkToTransactions])

    return (
        transaction && transactionsList
        ? (
            <TransactionItems
                title={"Upcoming Transactions"}
                hideBalance={true}
                items={transactionsList}
                hideTransactionCreate={true}
                preSelectAll={true}
            />
        ) : null
    )
}

export default UpcomingTransactions;